<template>
  <div class="lists">
    <div class="row not-margin info-user">
      <div class="col-md-12 text-left">
        <button v-on:click="create" class="btn btn-action"> {{ $t('admin.upload')}}</button>
      </div>
    </div>
    <div class="container-info margin-between-section">
      <table class="table table-condensed container-info margin-between-section tb-header" style="border-collapse:collapse;">
        <thead>
          <tr>
            <th>{{ $t('admin.user')}}</th>
            <th>{{ $t('admin.role')}}</th>
            <th class="show-desktop">{{ $t('admin.team')}}</th>
            <th class="show-desktop">{{ $t('admin.league')}}</th>
            <th class="show-desktop">{{ $t('admin.email')}}</th>
            <th>{{ $t('admin.actions')}}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(value, index) in data">
            <tr v-if="value.role.id == '6Wk2ojqf4D'" :key="index" class="accordion-toggle t-border" v-bind:index="index">
              <td data-toggle="collapse" :data-target="'#detail' + index" >{{value.fullname}}</td>
              <td data-toggle="collapse" :data-target="'#detail' + index" >{{value.position}}</td>
              <td class="show-desktop" data-toggle="collapse" :data-target="'#detail' + index" >{{value.team}}</td>
              <td class="show-desktop" data-toggle="collapse" :data-target="'#detail' + index" >{{value.league}}</td>
              <td class="show-desktop" data-toggle="collapse" :data-target="'#detail' + index" >{{value.username}}</td>
              <td ><button v-on:click="deleteUser(value, index)" class="delete_user"></button></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import User from '../parse/models/User'
import json from "@/assets/data/users.json";
import { bus } from "../main";

export default {
  name: "lists",
  data() {
    return {
      data: [],
      defaultOpenedDetails: [],
      showDetailIcon: false,
      notification: {
        disable: true,
        id: "",
        name: "",
        message: "",
      },
    };
  },
  beforeMount() {
    User.load().then(user => {
      this.data = user
    })
  },
  components: {},
  methods: {
    create(){
      this.$router.push('/create')
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
    closeAllOtherDetails(row, index) {
      this.defaultOpenedDetails = [row.id];
    },
    deleteUser(user, index) {

      this.notificationerror = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.error')
      }

      const params = {
        userId: user.id
      }
      
      User.removeUserList(params)
      .then((user) => this.removeTable(index))
      .catch(error => bus.$emit('sample', this.notificationerror))
      

    },
    removeTable(index) {
      
      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.user_delete')
      }

      bus.$emit('sample', this.notification)
      setTimeout(() => ( this.data.splice(index, 1)), 2000)
    }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* -- Tables */


.table td, .table th {
    vertical-align: middle;
}

.tb-header thead {
  border-bottom: 2px solid #dee2e6;
}

.tb-header thead tr th {
  font-size: 12px;
  color: rgb(138, 138, 138);
}

.table td{
  border: none;
}

.t-border{
  border-bottom: 1px solid #dee2e6;
}

/* -- Tables */


.btn-action{
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: left;
}

.info-user h1 {
  font-family: "plain medium", arial;
}

.info-user p {
  font-size: 12px;
}

.not-margin{
  padding: 0;
  margin: 5% 0 0 0;
}

.dropdown-toggle {
  font-size: 13px;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.dropdown {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  margin-left: 15px;
  margin-right: 5px;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-menu{
  background: #000;
  color: #fff;
  min-width: 20rem;
  padding: 20px;
  border: 0
}

.dropdown-item, .dropdown .dropdown-menu .has-link a{
  color: #fff;
  font-size: 12px;
  padding: 15px 0 15px 17px;
  opacity: 0.8;
  margin-left: 15px;
}

.principal-option{
  border-bottom: 1px solid;
  opacity: 1;
  margin-left: 0;
}

.principal-option img{
  width: 15px;
  vertical-align: middle;
  margin: 0 10px 3px -15px;
}

a.dropdown-item:hover, .dropdown .dropdown-menu .has-link a:hover, button.dropdown-item:hover {
  background-color: #000;
  color: #fff;
  text-decoration: underline;
}

.l-r {
  border-right: 1px solid rgb(221, 221, 221);
  padding-right: 15px;
}

.txt-left {
  text-align: left;
}

.txt-center {
  text-align: center;
}

.title-name {
  font-family: "plain medium", arial;
  font-size: 12px;
  margin-top: 5px;
}




small {
  margin: 5px 0;
  font-size: 0.775em;
}
.str {
  font-family: "plain medium", arial;
  font-size: 11px;
  text-decoration: underline;
}

.str-n {
  font-family: "plain medium", arial;
  font-size: 11px;
}

.margin-zero {
  margin: 0;
}

.padding-zero {
  padding: 0;
}

.delete_user {
  width: 25px;
  height: 25px;
  background-color: transparent;
  border: none;
  background: url("../assets/images/delete.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
}

.done {
  width: 25px;
  height: 25px;
  background-color: transparent;
  border: none;
  background: url("../assets/images/active.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
}

.image-play {
  width: 200px;
  height: 197px;
  object-fit: cover;
}

.form {
  padding: 5%;
  margin: 1% 0 0 0;
  background: #fff;
  border: 1px solid #000;
  height: 250px;
  display: flex;
}

.con-i {
  margin-top: 15px;
}

.form label {
  font-size: 11px;
  width: 120px;
  text-align: right;
  padding-right: 5px;
}

.form input {
  font-size: 12px;
  font-family: "plain medium", arial;
  width: 100px;
  border: 0;
  border-bottom: 1px solid #000;
}

.btn-action {
  border: 1px solid #000;
  background: #fff;
  padding: 5px 15px;
  font-size: 12px;
  margin-top: 5px;
}

.btn-action img {
  width: 20px;
  margin-right: 5px;
}



/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {

  .show-desktop{
    display: none;
  }

}

/* Larger than tablet */
@media (max-width: 768px) {}

/* Larger than phablet */
@media (max-width: 550px) {}

/* Larger than mobile */
@media (max-width: 400px) {}

</style>
